module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAgCAYAAAAMq2gFAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4QscFSYkmeO93wAAABl0RVh0Q29tbWVudABDcmVhdGVkIHdpdGggR0lNUFeBDhcAAADNSURBVEjHY2AgEfx40/H/x5uO/6TqY2KgExi1aNQi+lvE8n0dw38GBgaG1D2oEkumMTAi82OyGP5j46Orw2Ue3XzECMvl/w9VQATsOlAUwMThGqDyKXUVeA2e7TJQPkIPe5hLcPkMJg7jo8fFwKe6OU0dWOMCFyBW3eCNI3QfoMcJTD2huBp8cQTz4WwG4lLbgMURC3oOR3cJuWDAyjqS8xGxYOjEEXrqG7pxRGocDp6yDuZDYn006OojjDYDDHAGobZuSOltYDOPbj4CAF7KaDIxqM1SAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/game/assets/tanks/tank.png
// module id = 63
// module chunks = 0